import { BarSkeleton } from "./bar";
import { LineSkeleton } from "./line";
import { MetricSkeleton } from "./metric";
const Skeletons = {
    "metric": MetricSkeleton,
    "bar": BarSkeleton,
    "line": LineSkeleton,
    "area": LineSkeleton,
    "pie": BarSkeleton,
    'matrix': BarSkeleton,
    "table": BarSkeleton,
    'map': BarSkeleton,
    'sankey': BarSkeleton
};
export default Skeletons;
//# sourceMappingURL=index.js.map